export const MAX_FILES = 3; // The default amount of attachments allowed
export const MAX_SIZE = 100000000; // = 100 Mb
